export default __webpack_public_path__ + "static/media/IOT.44ba4159.jpg";